export default "__VITE_ASSET__htBzrYa0__"